import React from "react";
import Helmet from "react-helmet";

import Layout from '../components/layout';

import kritapas_img from '../assets/images/Kritapas_pic.jpg'
import reactVid from '../assets/images/react-video.png'
import simonGame from '../assets/images/simonGame.png'
import todoList from '../assets/images/todolistWithMongo.png'
import shop from '../assets/images/shop.png'
import devConnect from '../assets/images/devConnect.png'

class Homepage extends React.Component {
  render() {
    const siteTitle = "Kritapas | Portfolio";

    return (<Layout>
      <Helmet title={siteTitle}/>

      <section id="one" className="main style1">
        <div className="grid-wrapper">
          <div className="col-6">
            <header className="major">
              <h2>Hello.</h2>
            </header>
            <p className="intro">I'm a full stack developer. Passionate about developing web application. Love looking through cool design, Taylor Swift and Science.</p>

            <p>Graduated from Rochester Institutte of Technology in 2019</p>
            <p>Study game design and development</p>
            <p>Proficient in 3 language:</p>

            <p>Thai</p>
            <p>English</p>
            <p>Japanese</p>

            <p>
              <strong>Looking for opportunities</strong>
            </p>
          </div>

          <div className="col-6">
            <span className="image"><img src={kritapas_img} alt="Kritapas's Profile Picture"/></span>
          </div>
        </div>
      </section>

      <section id="two" className="main style2 special">
        <div className="grid-wrapper">
          <div className="col-12">
            <header className="minor">
              <h1>Project</h1>
              <ul className="minor-icons">
                <span className="icon style1 major fa-code"></span>
              </ul>
            </header>
          </div>
          <div className="col-4">
            <span className="image fit"><img src={shop} alt="Shop image"/></span>
            <h3>Cloth Shop Website</h3>
            <p>Using React-redux to create shopping website</p>
            <ul className="actions">
              <li>
                <a className='a-style' href="https://github.com/kxn9945/cloth-shop">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  Code
                </a>
                <a className='a-style' href="https://kritapas-shop-live.herokuapp.com/">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  Example
                </a>
              </li>
            </ul>
          </div>
          <div className="col-4">
            <span className="image fit"><img src={devConnect} alt="Developer Social Media"/></span>
            <h3>Platform to connect developer</h3>
            <p>Create profile and connect with other developer inside the community</p>
            <ul className="actions">
              <li>
                <a className='a-style' href="https://kritapas-devconnect.herokuapp.com/">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  Code
                </a>
                <a className='a-style' href="https://kritapas-devconnect.herokuapp.com/">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  Example
                </a>
              </li>
            </ul>
          </div>
          <div className="col-4">
            <span className="image fit"><img src={reactVid} alt="reactVid"/></span>
            <h3>Display Video with React</h3>
            <p>Pulling data from youtube API to display video on the website</p>
            <ul className="actions">
              <li>
                <a className='a-style' href="https://github.com/kxn9945/react-video">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  Code
                </a>
                <a className='a-style' href="https://react-video1.herokuapp.com/">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  Example
                </a>
              </li>
            </ul>
          </div>
          <div className="col-4">
            <span className="image fit"><img src={todoList} alt="todoList"/></span>
            <h3>To do list that can add/remove item</h3>
            <p>Make a todoList that have routing to custom url</p>
            <ul className="actions">
              <li>
                <a className='a-style' href="https://github.com/kxn9945/todolist-mongo">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  Code
                </a>
                <a className='a-style' href="https://todolist-mongoatlus.herokuapp.com/">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  Example
                </a>
              </li>
            </ul>
          </div>



        </div>
      </section>

      <section id="three" className="main style2 special">
        <div className="grid-wrapper">
          <div className="col-12">
            <header className="minor">
              <h1>Flutter</h1>
              <ul className="minor-icons">
                <span className="icon style1 major fa-code"></span>
              </ul>
            </header>
          </div>

          <div className="col-4">
            <span className="image fit">
              <iframe title="pointClickAdventure" src='https://gfycat.com/ifr/IdenticalDecentBluewhale?autoplay=0' frameBorder='0' scrolling='no' allowFullScreen="allowFullScreen" width='320' height='480'></iframe>
            </span>
            <h3>Point and Click Adventure</h3>
            <ul className="actions">
              <li>
                <a className='a-style' href="https://github.com/kxn9945/Flutter-pointClickAdventure">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  Code
                </a>
              </li>
            </ul>
          </div>

          <div className="col-4">
            <span className="image fit">
              <iframe title="diceRoll" src='https://gfycat.com/ifr/PoisedBlaringCaterpillar?autoplay=0' frameBorder='0' scrolling='no' allowFullScreen="allowFullScreen" width='320' height='480'></iframe>
              <p></p>
            </span>
            <h3>Dice Roll</h3>
            <ul className="actions">
              <li>
                <a className='a-style' href="https://github.com/kxn9945/flutter-diceRoll">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  Code
                </a>
              </li>
            </ul>
          </div>

        </div>
      </section>
      <section id="four" className="main style1 special">
        <div className="container">
          <header className="major">
            <h2>Get In Touch</h2>
          </header>
          <div className="contact-me">

            <h3>I'm currently available for full time work</h3>
            <p>Phone number: (+1) 585-369-9921</p>
            <p>Email: kritapas333@hotmail.com</p>
            <p>OR Click below</p>
            <a className='a-style' className="btn" href="mailto:kritapas333@hotmail.com">CONTACT ME</a>
          </div>
        </div>
      </section>
    </Layout>);
  }
}

export default Homepage;
